<template>
  <div class="box is-radiusless">
    <form @submit.prevent="submitForm">
      <div class="field">
        <label for="" class="label">Customer Name</label>
        <div class="control">
          <select class="input" v-model="leadId">
            <option disabled value="" selected>Please select one</option>
            <option v-for="lead in leads" :key="lead.leadId" :value="lead.leadId">{{lead.name}}</option>
          </select>
        </div>
      </div>
      <div class="columns">
        <div class="field column">
          <label for="" class="label">Date</label>
          <div class="control">
            <input class="input is-radiusless" type="date" v-model="formData.occurred_on">
          </div>
        </div>
        <div class="field column">
          <label for="" class="label">Type</label>
          <div class="control">
            <div class="field is-grouped">
            <input class="is-checkradio is-block is-success" id="exampleRadioInline1" value="visit" type="radio" name="exampleRadioInline" checked="checked" v-model="formData.type">
            <label for="exampleRadioInline1">Visit</label>
            <input class="is-checkradio is-block" id="exampleRadioInline2" type="radio" value="call" name="exampleRadioInline" v-model="formData.type">
            <label for="exampleRadioInline2">Phone call</label>
            </div>
          </div>
        </div>
      </div>
      <div class="field">
        <label for="" class="label">Notes</label>
        <div class="control"><textarea type="textarea" class="textarea is-radiusless" v-model="formData.notes"></textarea></div>
      </div>
      <div class="field is-grouped is-grouped-centered">
        <div class="control"><a @click="cancelForm" class="button is-light is-radiusless">Cancel</a></div>
        <div class="control"><button type="submit" class="button is-primary is-radiusless">Save</button></div>
      </div>
    </form>
  </div>
</template>


<script>
  import { getLeads, patchEngagement, postEngagement } from '@/utils/api';
  import moment from 'moment';

  export default {
  async mounted() {
    console.log(this.year)
    if (this.lead) {
      this.leadId = this.lead;
    }
    try {
      this.leads = await getLeads();
      this.updateDate();
    } catch (e) {
      console.error(e);
    }
  },
  props: ['lead', 'year', 'month', 'day', 'engagementToEdit'],
  watch: {
    engagementToEdit(val) {
      if (val && val.lead_id) {
        this.leadId = val.lead_id;
        this.engagementId = val.engagement_id;
        this.formData.occurred_on = val.occurred_on;
        this.formData.type = val.type;
        this.formData.notes = val.notes;
      } else {
        this.engagementId = null;
        this.leadId = null;
        this.formData = {
          occurred_on: this.datePickerDate,
          type: null,
          notes: null,
        };
      }
    },
    year() {
      this.updateDate();
    },
    month() {
      this.updateDate();
    },
    day() {
      this.updateDate();
    },
    formData() {
      console.log('updating formdata', this.formData.occurred_on)
    },
  },
  data() {
    return {
      leads: [],
      leadId: null,
      engagementId: null,
      formData: {
        occurred_on: this.datePickerDate,
        type: null,
        notes: null,
      },
    };
  },
  methods: {
    updateDate() {
      try {
        this.formData.occurred_on = this.datePickerDate;
      } catch (e) {
        console.error(e);
      }
    },
    async submitForm() {
      try {
        if (this.engagementId) {
          const result = await patchEngagement(this.leadId, this.engagementId, this.formData);
          this.$emit('done', { engagementId: this.engagementId, ...this.formData });
        } else {
          const result = await postEngagement(this.leadId, this.formData);
          this.$emit('done');
        }
      } catch (err) {
        console.error(err);
      }
    },
    cancelForm() {
      this.$emit('cancel');
    },
  },
  computed: {
    datePickerDate() {
      return moment({
        year: parseInt(this.year, 10),
        month: parseInt(this.month, 10) - 1,
        day: parseInt(this.day, 10),
      }).format('YYYY-MM-DD');
    },
  },
};
</script>
